// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"60f1e2a8","78":"a319ea5c","105":"14d59963","141":"ed3a6393","286":"d19fdbcd","324":"b8582168","434":"0b7af45b","444":"0c31f987","453":"d13396ad","478":"18517951","622":"c85ef8e0","708":"568c6648","714":"0ca60c7f","823":"0cbca5fd","932":"59018c1b","979":"f2c8e092"}[chunkId] + ".chunk.js";
};